<form action="" [formGroup]="galleryForm">
  <h5 class="sub-title mb-3">{{ datas.title }} Gallery</h5>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="form-rows">
        <mat-form-field class="material-full-width" appearance="outline">
          <mat-label>Gallery Tag <span class="text-danger">*</span></mat-label>
          <input
            matInput
            placeholder="Enter Gallery Tag"
            formControlName="galleryTags"
            [ngClass]="{
              'is-invalid': add.galleryTags.touched && add.galleryTags.errors
            }"
          />
          <mat-error *ngIf="add.galleryTags.touched && add.galleryTags.errors">
            <span *ngIf="add.galleryTags.errors.required"
              >Gallery Tag is required</span
            >
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="p-relative">
        <p class="logo-span">
          Gallery Image <span class="text-danger">*</span>
        </p>
        <div class="text-center">
          <div class="circle">
            <img class="profile-pic" [src]="image_url" />
          </div>
          <div>
            <label for="files" class="p-image">Upload Gallery</label>
            <input
              class="file-upload"
              (change)="onSelectImage($event)"
              id="files"
              type="file"
              accept="image/*"
            />
          </div>
        </div>
        <p>
          <span class="noti-span"
            >(Supported Format: png,jpg,jpeg) <br />(maximum Upload file size:
            10MB) <br />Suggested Image Dimensions:1280 x 853</span
          >
        </p>
        <p *ngIf="logoCheck == true" class="text-danger">
          Gallery Image is required
        </p>
      </div>
    </div>
  </div>
  <div class="text-center mt-5">
    <button
      class="mr-2 new-btn-color2"
      mat-raised-button
      color="warn"
      (click)="cancelGallery()"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      class="new-btn-color"
      color="primary"
      (click)="saveGallery()"
    >
      Save
    </button>
  </div>
</form>
